import { TLanguage } from "../Common/other";

export const LANGUAGES: { [key in TLanguage]: TLanguage } = {
  en: "en",
  vn: "vn",
};
